import React, {Component} from 'react';
import { HashRouter, Route, Switch, Redirect} from 'react-router-dom';

import App from "@/views/App";
import Login from "@/views/login";
import libraryManageHome from '@/views/home/libraryManageHome' //  博协用户
import professionalHome from '@/views/home/professionalHome'  //专家
import libraryUserHome from '@/views/home/libraryUserHome'  //  博物馆用户
import Err404 from '@/views/404/no'
import { getStorage} from "@/utils";
import MainContent from "@/views/mainContent";
import {message} from "antd";
import {clearboth} from "../utils/clear";
import standardManageRouter from './standardManageRouter'
const routers = [
  standardManageRouter,
];

function guards(Cmp){
  return () => {
    const login = sessionStorage.getItem('login')
    if (login) {
      return <Cmp/>
    } else {
      message.error('您还未登录,请先登录系统',2)
      clearboth()
      window.location.href = '/'
    }
  }
}

function guardslogin(Cmp){
  return () => {
    const login = sessionStorage.getItem('login')
    if (login) {
      if (getStorage('userList') === null) {
        clearboth()
        return <Cmp/>
      } else {
        const type = getStorage('userList').clerklevel
        if (type == 8) {
          return <Redirect to="/home" />
        } else if (type == 16 || type == 17) {
          return <Redirect to="/homeCentral" />
        } else if (type == 3 || type == 4) {
          return <Redirect to="/homeScore" />
        }
      }
    } else {
      clearboth()
      return <Cmp/>
    }
  }
}

const renderRoutes = (routers) => {
  return routers.map((item, index)=>{
    if(item.children){
      let Com = item.component;
      return (
          <Com key={index}>
            {renderRoutes(item.children)}
          </Com>
      )
    }else{
      return (
          <Route path={item.path} component={guards(item.component)} exact={item.exact} key={index} />
      )
    }
  })
};
export default class RouteConfig extends Component{
  render(){
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={guardslogin(Login)}  />
          <Route exact path='/login' component={guardslogin(Login)} />
          <App>
            <MainContent>
              <Route exact path='/home' component={guards(libraryUserHome)} />
              <Route exact path='/homeCentral' component={guards(libraryManageHome)} />
              <Route exact path='/homeScore' component={guards(professionalHome)} />
              {renderRoutes(routers)}
            </MainContent>
          </App>
          <Route path="/error" component={Err404}/>
          <Route path="*" render={()=><Redirect to='/error'/>}/>
        </Switch>
      </HashRouter>
    )
  }
}
